function injectStyle (context) {
  require("!!../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"optionsId\":\"0\",\"vue\":true,\"id\":\"data-v-026f923c\",\"scoped\":true,\"sourceMap\":false}!sass-loader?{\"sourceMap\":true}!sass-resources-loader?{\"resources\":[\"/app/chatmods-ui/src/assets/style/_functions.scss\",\"/app/chatmods-ui/src/assets/style/_variables.scss\",\"/app/chatmods-ui/src/assets/style/_mixins.scss\"]}!@/components/game/implementations/uk/potion/_components/prize/prize.scss")
}
/* script */
export * from "!!ts-loader!../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./prize.vue"
import __vue_script__ from "!!ts-loader!../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./prize.vue"
/* template */
import {render as __vue_render__, staticRenderFns as __vue_static_render_fns__} from "!!../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-026f923c\",\"hasScoped\":true,\"optionsId\":\"0\",\"buble\":{\"transforms\":{}}}!@/components/game/implementations/uk/potion/_components/prize/prize.html"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-026f923c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../../../../../../node_modules/vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/game/implementations/uk/potion/_components/prize/prize.vue
// module id = null
// module chunks = 